import { LDateTime } from '@app/components/date/LDateTime';
import { UserLabel } from '@app/components/users/UserLabel';
import { FragmentDuration } from '@app/modules/fragments/components/type/FragmentDuration';
import { DateTimeStr } from '@mi-front/core';
import { LocaleRelativeTime } from '@mi-front/ui';
import { Box, Stack, Tooltip } from '@mui/material';
import { useFragment } from '../../hooks/useFragment';
import { FragmentMetadataTags } from './FragmentTags';

/**
 * Fragment metadata row: date, duration, tags, and creator.
 * No card surface — plain text only. Logger actions live under the media player.
 */
export function FragmentMetadata() {
  const { fragment, station } = useFragment();
  const hasTags = !!fragment.tags?.length;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={1}
        alignItems="center"
        sx={{ typography: 'body2', color: 'text.secondary' }}
      >
        <LDateTime
          value={fragment.from as DateTimeStr}
          showRelative="inline"
          tz={station.timezone}
        />
        <Box component="span">•</Box>
        <FragmentDuration fragment={fragment} />
        {hasTags && (
          <>
            <Box component="span">•</Box>
            <FragmentMetadataTags stationSlug={station.slug} tags={fragment.tags} />
          </>
        )}
      </Stack>
      {fragment.creator ? (
        <Tooltip title={<LocaleRelativeTime value={fragment.createdAt} />} placement="top">
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              typography: 'body2',
              color: 'text.secondary',
              flexShrink: 0,
            }}
          >
            <UserLabel
              showIcon
              iconSize="medium"
              id={fragment.creator.id}
              user={{
                name: fragment.creator.name ?? '',
                surname: fragment.creator.surname ?? '',
                email: fragment.creator.email ?? '',
                avatar: fragment.creator.avatar,
              }}
            />
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  );
}
